module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/incorrect@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/incorrect@2x.png
// module id = 711
// module chunks = 0